import { handleActions, combineActions } from "redux-actions";

import { pageDefaultState } from "./page.state";
import {
    SET_HISTORY,
    RENDER_AT_TOP,
    OPEN_QUOTE_POPUP,
    CLOSE_QUOTE_POPUP,
    SHOW_LOADING,
    HIDE_LOADING,
    LOAD_DEFAULT_CHANNEL_DONE,
    setQueryString,
    OPEN_APP_MODAL,
    CLOSE_APP_MODAL,
} from "./page.actions";

export const pageReducer = handleActions(
    {
        [SET_HISTORY]: (state, action) => ({
            ...state,
            history: action.payload,
        }),
        [RENDER_AT_TOP]: (state, action) => ({
            ...state,
            mainContainer: {
                topCmp: action.payload,
            },
        }),
        [OPEN_QUOTE_POPUP]: state => ({
            ...state,
            quotePopup: {
                opened: true,
            },
        }),
        [CLOSE_QUOTE_POPUP]: state => ({
            ...state,
            quotePopup: {
                opened: false,
            },
        }),
        [LOAD_DEFAULT_CHANNEL_DONE]: state => ({
            ...state,
            partnerIsLoad: true,
        }),

        [combineActions(SHOW_LOADING, HIDE_LOADING)]: (state, action) => ({
            ...state,
            loadingOverlay: {
                ...state.loadingOverlay,
                ...action.payload,
            },
        }),
        [setQueryString]: (state, { payload }) => ({
            ...state,
            queryString: payload,
        }),
        [OPEN_APP_MODAL]: (state, { payload }) => ({
            ...state,
            appModal: {
                ...state.appModal,
                ...payload,
                isOpen: true,
            },
        }),
        [CLOSE_APP_MODAL]: state => ({
            ...state,
            appModal: {
                ...state.appModal,
                isOpen: false,
                type: null,
                actionType: null,
            },
        }),
    },
    pageDefaultState
);
